<template>
  <div v-if="dashboardModalStatePresenter.isAddingDashboardUser.value" class="h-full flex justify-center items-center">
    <LoadingPanel />
  </div>
  <div v-else-if="!submissionStatusPresenter.hasData.value" class="w-full h-full flex justify-center items-center">
    {{ $t('message.noData') }}
  </div>
  <VueApexCharts
    v-else
    height="100%"
    :options="submissionStatusPresenter.chartOptions.value"
    :series="submissionStatusPresenter.chartSeries.value"
    type="bar"
  />
</template>

<script lang="ts">
import { defineComponent, SetupContext } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import LoadingPanel from '@/presentation/components/Loading/LoadingPanel.vue'
import { useDashboardModalStatePresenter } from '@/presentation/composables/dashboard/useDashboardModalStatePresenter'
import { useSubmissionStatusPresenter } from '@/presentation/composables/dashboard/useSubmissionStatusPresenter'

export default defineComponent({
  components: { VueApexCharts, LoadingPanel },
  setup(props, ctx: SetupContext) {
    const dashboardModalStatePresenter = useDashboardModalStatePresenter()
    const submissionStatusPresenter = useSubmissionStatusPresenter()

    return {
      dashboardModalStatePresenter,
      submissionStatusPresenter
    }
  }
})
</script>

<style lang="postcss" scoped></style>
